import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { SalesChannelService } from 'src/app/_business-dashboard/_services/bizz-sales-channel.services';
import { Status } from 'src/app/_models/coupon-management';
import { AppBaseDataService } from 'src/app/_services/app-base-data.service';
import { ConnMessageService } from 'src/app/_services/conn-message.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { CouponCodeService } from 'src/app/_business-dashboard/_services/bizz-coupon-codes.services';
@Component({
  selector: 'app-bizz-sales-channel-form',
  templateUrl: './bizz-sales-channel-form.component.html',
  styleUrls: ['./bizz-sales-channel-form.component.scss']
})
export class BizzSalesChannelFormComponent implements OnInit {

  destroy$: Subject<boolean> = new Subject<boolean>()
  editform: FormGroup

  // Bind the dropdown values to the form from the service model
  statusList: any[] = Status;

  fullNameDescription = `Name of the channel i.e Facebook, Instagram or
  a sales person “John Moris”`

  salesChannelData: any;
  code: any[] = []
  url: any[] = []
  couponArray: any[] = [];

  @Input() isNew: boolean = true
  @Input() isViewOnly: boolean
  @Output() onSubmit = new EventEmitter();

  // Coupon management variables
  allCoupons: any[] = [];
  filteredCoupons: any[] = [];
  assignedCoupons: any[] = [];
  selectedCoupon: any = null;
  originalCoupons: any[] = []; // used to track initially saved coupons for diff detection
  showCouponModal: boolean = false;
  errorMessage: string = '';
  constructor(
    private _fb: FormBuilder,
    public _salesChannelService: SalesChannelService,
    private _spinner: NgxSpinnerService,
    private _connMessageService: ConnMessageService,
    public _abd: AppBaseDataService,
    private clipboard: Clipboard,
    public couponCodeServices: CouponCodeService,

  ) { }

  ngOnInit(): void {
    this.errorMessage = '';
    this.salesChannelData = {
      fullName: this._salesChannelService.activeItem?.fullName,
      status: this._salesChannelService.activeItem?.status === true ? 1 : 0,
      description: this._salesChannelService.activeItem?.description,
    }
    this.initForm();

    if (!this.isNew && this._salesChannelService.activeItem?.salesChannelCoupon?.length > 0) {
      // Map existing coupons

      this.assignedCoupons = this._salesChannelService.activeItem.salesChannelCoupon.map((c: any) => ({
        id: c.id,
        discountId: c.discountId,
        name: c.couponCodesList?.[0] || c.couponCodes || c.name || '' || c.couponCode,
      }));

      // ✅ Deep clone for diff comparison later
      this.originalCoupons = JSON.parse(JSON.stringify(this.assignedCoupons));
    } else {
      this.originalCoupons = [];
    }

    this.loadAllCoupons();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  copy(item: any) {
    this.clipboard.copy(item.y);
    this._connMessageService.showToastMessage('copied successfully', 'success');
  }


  get f() {
    return this.editform.controls;
  }

  initForm() {
    this.editform = this._fb.group({
      fullName: [{ value: this.salesChannelData.fullName, disabled: this.isViewOnly }, [Validators.required, Validators.maxLength(255)]],
      status: [{ value: this.salesChannelData.status, disabled: this.isViewOnly }, [Validators.required]],
      description: [{ value: this.salesChannelData.description, disabled: this.isViewOnly }, Validators.maxLength(50000)],
    })
  }

  async saveFn() {
    this._abd.showSpinner();


    const formData: any = {
      fullName: this.f.fullName.value?.trim(),
      status: this.f.status.value,
      description: this.f.description.value?.trim(),
    };

    // ✅ Wait for Angular to apply array changes (fix race condition)
    await new Promise(resolve => setTimeout(resolve, 0));

    console.log('💾 assignedCoupons before diff:', this.assignedCoupons);
    console.log('💾 originalCoupons before diff:', this.originalCoupons);

    // 🧩 Normalize all coupons before comparison
    this.assignedCoupons = this.assignedCoupons.map(c => ({
      ...c,
      discountId: c.discountId || c.id,  // if missing, use id
    }));
    this.originalCoupons = this.originalCoupons.map(c => ({
      ...c,
      discountId: c.discountId || c.id,
    }));

    // 🟧 Prepare arrays for comparison
    const current = this.assignedCoupons.map(c => ({
      discountId: c.discountId,
      name: c.name,
    }));

    const original = this.originalCoupons.map(c => ({
      discountId: c.discountId,
      name: c.name,
    }));

    // 🟩 Detect actual changes
    const added = current.filter(
      c => !original.some(o => o.discountId === c.discountId)
    );
    const removed = original.filter(
      o => !current.some(c => c.discountId === o.discountId)
    );

    // 🟦 Only include couponChanges if real differences exist
    if (added.length > 0 || removed.length > 0) {
      formData.couponChanges = {
        addedCoupons: added.map(c => ({
          discountId: c.discountId,
          couponCode: c.name,
        })),
        removedCouponIds: removed.map(c => c.discountId),
      };
    }

    this.errorMessage = '';
    const apiCall = this.isNew
      ? this._salesChannelService.addChannelV2(formData)
      : this._salesChannelService.updateChannelV2(this._salesChannelService.activeItem?.id, formData);

    apiCall.subscribe({
      next: (res) => {
      
        if (res.success) {
          this.cancelButtonClick();
          this.onSubmit.emit(true);
          this._connMessageService.showToastMessage(
            this.isNew ? 'Channel added successfully' : 'Channel updated successfully',
            'success'
          );
        } else {
          this.errorMessage = res.message || 'Channel could not be saved properly.';
          this._connMessageService.showToastMessage(
            'Channel could not be saved properly.',
            'error'
          );
        }
      },
      error: (res) => {
         this.errorMessage =res.error.message || 'Request failed. Please try again.';
        this._connMessageService.showToastMessage('Request failed. Please try again.', 'error');
      },
      complete: () => {
        this._abd.hideSpinner();
      },
    });
  }

  cancelButtonClick() {
    this._salesChannelService.showEditChannel = false;
    this._salesChannelService.showNewEditChannel = false;
  }

  isCouponLoading = false;

  loadAllCoupons() {
    this._spinner.show('couponLoader');

    const obj = { PageNo: 0, PageSize: 2000000, filterValue: '', discountValue: null, orderParam: '', orderBy: '' };

    this.couponCodeServices.getAllCouponCodes(obj).subscribe({
      next: (res) => {
        if (res.success && res.data?.length > 0) {
          // 👉 Map EVERYTHING (no filtering against originalCoupons here)
          this.allCoupons = res.data.map((c: any) => ({
            id: c.id,
            discountId: c.id, // id = discountId
            name: c.couponCodesList?.[0] || c.couponCodes || c.discountName || 'Unnamed Coupon'
          }));

          // Show only not-assigned (original can stay assigned and still be hidden)
          this.filteredCoupons = this.getAvailableCoupons();
        }
      },
      error: () => this._connMessageService.showToastMessage('Failed to load coupons', 'error'),
      complete: () => this._spinner.hide('couponLoader'),
    });
  }



  getAvailableCoupons() {
    const assignedIds = new Set(this.assignedCoupons.map(c => c.discountId));
    return this.allCoupons.filter(c => !assignedIds.has(c.discountId));
  }

  // --- Filter coupons based on search query ---
  filterCoupons(event: any) {
    const query = (event.query || '').toLowerCase();

    const excludedIds = this.assignedCoupons.map(c => c.discountId);

    this.filteredCoupons = this.allCoupons.filter(coupon => {
      const notExcluded = !excludedIds.includes(coupon.discountId);
      const matchQuery = coupon.name.toLowerCase().includes(query);
      return notExcluded && matchQuery;
    });
  }

  // --- Add coupon from dropdown ---
  addCoupon(coupon: any, couponAuto: any) {
    if (!coupon) return;

    if (!this.assignedCoupons.some(ac => ac.discountId === coupon.discountId)) {
      this.assignedCoupons.push(coupon);
    }

    // do NOT add to originalCoupons here (only DB-saved ones belong there)
    this.filteredCoupons = this.getAvailableCoupons();

    this.selectedCoupon = null;
    couponAuto.inputEL.nativeElement.value = '';
  }

  removeCouponByIndex(index: number) {
    if (index < 0 || index >= this.assignedCoupons.length) return;
    this.assignedCoupons.splice(index, 1);
    this.assignedCoupons = [...this.assignedCoupons]; // trigger change detection
    this.filteredCoupons = this.getAvailableCoupons(); // reappear in dropdown
  }

  removeCoupon(coupon: any) {
    // remove from current assigned
    this.assignedCoupons = this.assignedCoupons.filter(
      ac => ac.discountId !== coupon.discountId
    );

    // also remove from original snapshot so it can reappear
    this.originalCoupons = this.originalCoupons.filter(
      oc => oc.discountId !== coupon.discountId
    );

    // rebuild dropdown
    this.filteredCoupons = this.getAvailableCoupons();
  }

  openNewCouponForm() {
    this.couponCodeServices.activeItem = null;      // ensure NEW form
    this.showCouponModal = true;              // open modal

  }

  closeCouponModal() {
    this.showCouponModal = false;
  }

  onCouponCreated(newCoupon: any) {
    if (!newCoupon) return;

    // Auto-add to assigned list
    this.assignedCoupons.push({
      name: newCoupon.discountName,
      id: newCoupon.id,
      discountId: newCoupon.id
    });

    // Reload coupon dropdown list
    this.loadAllCoupons();

    //this._connMessageService.showToastMessage("Coupon added successfully.", "success");
  }
} 